import { Routes, Route, Navigate } from 'react-router-dom';

import { AppLayout } from '@/components/layout/AppLayout';
import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { DashboardPage } from '@/pages/DashboardPage';
import { DevicesPage } from '@/pages/DevicesPage';
import { SitesPage } from '@/pages/SitesPage';
import { PreviewPage } from '@/pages/PreviewPage';
import { TasksPage } from '@/pages/TasksPage';
import { LoginPage } from '@/pages/LoginPage';
import { FogDashboardPage } from '@/pages/FogDashboardPage';
import { FogHostsPage } from '@/pages/FogHostsPage';
import { FogImagesPage } from '@/pages/FogImagesPage';
import { FogTasksPage } from '@/pages/FogTasksPage';
import { SettingsPage } from '@/pages/SettingsPage';
import { DeviceGroupsPage } from '@/pages/DeviceGroupsPage';
import { ScansPage } from '@/pages/ScansPage';
import { RoomsPage } from '@/pages/RoomsPage';
import { InventoryPage } from '@/pages/InventoryPage';
import DeviceStatusPage from '@/pages/DeviceStatusPage';
import { QueuePage } from '@/pages/QueuePage';
import { AdUsersPage } from '@/pages/AdUsersPage';

export function AppRoutes() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<LoginPage />} />

      {/* Protected routes */}
      <Route element={<ProtectedRoute />}>
        <Route element={<AppLayout />}>
          {/* Default redirect to Dashboard */}
          <Route index element={<Navigate to="/dashboard" replace />} />

          {/* Main application routes */}
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/fog" element={<FogDashboardPage />} />
          <Route path="/fog/hosts" element={<FogHostsPage />} />
          <Route path="/fog/images" element={<FogImagesPage />} />
          <Route path="/fog/tasks" element={<FogTasksPage />} />
          <Route path="/devices" element={<DevicesPage />} />
          <Route path="/groups" element={<DeviceGroupsPage />} />
          <Route path="/sites" element={<SitesPage />} />
          <Route path="/rooms" element={<RoomsPage />} />
          <Route path="/inventory" element={<InventoryPage />} />
          <Route path="/preview" element={<PreviewPage />} />
          <Route path="/tasks" element={<TasksPage />} />
          <Route path="/scans" element={<ScansPage />} />
          <Route path="/queue" element={<QueuePage />} />
          <Route path="/status" element={<DeviceStatusPage />} />
          <Route path="/ad-users" element={<AdUsersPage />} />
          <Route path="/settings" element={<SettingsPage />} />

          {/* Catch-all redirect */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Route>
      </Route>
    </Routes>
  );
}

// Route path constants for type-safe navigation
export const routes = {
  login: '/login',
  dashboard: '/dashboard',
  fog: '/fog',
  fogHosts: '/fog/hosts',
  fogImages: '/fog/images',
  fogTasks: '/fog/tasks',
  devices: '/devices',
  groups: '/groups',
  sites: '/sites',
  rooms: '/rooms',
  inventory: '/inventory',
  preview: '/preview',
  tasks: '/tasks',
  scans: '/scans',
  queue: '/queue',
  status: '/status',
  adUsers: '/ad-users',
  settings: '/settings',
} as const;

export type RoutePath = (typeof routes)[keyof typeof routes];
